<template>
    <transition name="fade" mode="out-in">
        <div class="pop__image" v-if="isActive">
            <div class="pop__image__overlay"></div>
            <div class="pop__image__box">
                <header class="pop__image__box_header">
                    <div class="pop__image__box_header_close">
                        <component-button
                            :name="'pop-image-close'"
                            :icon="true"
                            :icon-name="'x'"
                            :icon-raw="true"
                            @click="closeNotify"
                        ></component-button>
                    </div>
                </header>
                <div class="pop__image__box_main">
                    <div class="pop__image__box_main_image">
                        <component-image
                            :url="url"
                            :id="id"
                            :alt="alt"
                            :size="size"
                            :full-height="true"
                            :clickable="false"
                        ></component-image>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ComponentImage from '@/components/default/shared/ComponentImage'
import { getDomPath } from '@/functions'
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'pop-image',
  components: { ComponentButton, ComponentImage },
  data () {
    return {
      isActive: false,
      url: '',
      id: '',
      alt: '',
      size: ''
    }
  },
  methods: {
    closeNotify: function () {
      this.isActive = false
    },
    openNotify: function () {
      this.isActive = true
    },
    setUrl (value) {
      this.url = value
    },
    setId (value) {
      this.id = value
    },
    setSize (value) {
      this.size = value
    },
    setAlt (value) {
      this.alt = value
    }
  },
  updated () {
    let self = this
    let overlay = document.getElementsByClassName('pop__image__overlay')
    for (let i = 0; i < overlay.length; i++) {
      overlay[i].addEventListener('click', function () {
        self.closeNotify()
      })
    }
  },
  mounted () {
    const domItem = this.$el
    const domPath = getDomPath(domItem)

    for (let i in domPath) {
      const domLoopItem = domPath[i]
      if (domLoopItem.classList && domLoopItem.classList.contains('pop')) {
        domLoopItem.append(domItem)
        break
      }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/popimage";
</style>
